export default {
  menuItems: "عناصر القائمة",
  manageRestaurantMenu: "إدارة قائمة المطعم",
  addItem: "إضافة عنصر",
  searchItemName: "ابحث عن اسم العنصر",
  allCategories: "كل الفئات",
  mainCourse: "الطبق الرئيسي",
  rice: "أرز",
  starters: "المقبلات",
  dessert: "الحلويات",
  item: "عنصر",
  items: "عناصر",
  selected: "محدد",
  enable: "تفعيل",
  disable: "تعطيل",
  image: "الصورة",
  category: "الفئة",
  price: "السعر",
  status: "الحالة",
  action: "الإجراء",
  noItemsFound: "لا توجد عناصر",
  available: "متوفر",
  unavailable: "غير متوفر",

  //menuItemsModal

  editItem: "تعديل العنصر",
  addNewItem: "إضافة عنصر جديد",
  itemName: "اسم العنصر",
  enterItemName: "أدخل اسم العنصر",
  select: "اختر",
  enterPrice: "أدخل السعر",
  portionSize: "حجم الحصة",
  itemImage: "صورة العنصر",
  clickToUploadImage: "اضغط لرفع الصورة",
  saveItem: "حفظ العنصر",
  fillAllRequiredFields: "يرجى تعبئة جميع الحقول المطلوبة",
  pleaseUploadValidImage: "يرجى رفع صورة صحيحة",
  cancel: "إلغاء",
  description: "الوصف"
};